export type Currency = 'EUR' | 'USD';

export const currencySymbols = { EUR: '€', USD: '$' };
